/**************************************************
 * Nombre:       Formacion_Razones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Razones from "../../../Tarjetas/Tarjeta_Razones";

const Formacion_Razones = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={6}
                    >

                        {item && item.razones && item.razones.map((it, index) => (
                            <Grid key={index+'569w'} container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Razones item={it}/>
                            </Grid>
                        ))}


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Formacion_Razones

const items = [1, 2, 3]